import { fromJS } from 'immutable';

import * as actions from './actions';

const initialState = fromJS({
  isLoading: 0,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE.REQUEST:
    case actions.DELETE.REQUEST:
    case actions.FETCH.REQUEST:
    case actions.PATCH.REQUEST: {
      return state.set('isLoading', state.get('isLoading') + 1);
    }

    case actions.CREATE.FAILURE:
    case actions.CREATE.SUCCESS:
    case actions.DELETE.FAILURE:
    case actions.DELETE.SUCCESS:
    case actions.FETCH.FAILURE:
    case actions.FETCH.SUCCESS:
    case actions.PATCH.FAILURE:
    case actions.PATCH.SUCCESS: {
      return state.set('isLoading', state.get('isLoading') - 1);
    }

    default:
      return state;
  }
}
